var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0078125,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#808080",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25195 11.9355C6.1582 12.0332 6.03125 12.082 5.87109 12.082C5.71094 12.082 5.58203 12.0332 5.48438 11.9355C5.39062 11.8379 5.34375 11.7051 5.34375 11.5371V4.08984C5.34375 3.92187 5.39062 3.78906 5.48438 3.69141C5.58203 3.59375 5.71094 3.54492 5.87109 3.54492H8.36133C9.1543 3.54492 9.80273 3.79883 10.3066 4.30664C10.8145 4.81055 11.0684 5.46094 11.0684 6.25781C11.0684 7.05859 10.8145 7.71289 10.3066 8.2207C9.79883 8.72852 9.14648 8.98242 8.34961 8.98242H6.39844V11.5371C6.39844 11.7051 6.34961 11.8379 6.25195 11.9355ZM6.39844 8.04492H8.08594C8.6875 8.04492 9.1543 7.88867 9.48633 7.57617C9.81836 7.25977 9.98438 6.82031 9.98438 6.25781C9.98438 5.69531 9.81836 5.25977 9.48633 4.95117C9.1582 4.63867 8.69141 4.48242 8.08594 4.48242H6.39844V8.04492Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/P.f5f6c47fac6d8d9aa57d15f416953a89.svg";
export { ForwardRef as ReactComponent };